module.exports = __webpack_public_path__ + "img/everyday-banana-bread.41964bd1.jpg";